// Register.js
import React, { useState } from 'react';
import Navigation from '../Navbar/Navbar';
import './Register.css';
import { Container, Card, Form, Button, Alert, Row, Col } from 'react-bootstrap';
import { PersonCircle, ShieldLock, PersonFillAdd } from 'react-bootstrap-icons';
import axios from 'axios';

const apiUrl = "/api";

const Register = () => {
  const [formData, setFormData] = useState({
    name: '',
    username: '',
    password: '',
    confirmPassword: ''
  });
  const [registerError, setRegisterError] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleRegister = async () => {
    if (!formData.name.trim() || !formData.username.trim() || !formData.password || !formData.confirmPassword) {
      setRegisterError('All fields are required.');
      return;
    }

    if (formData.password !== formData.confirmPassword) {
      setRegisterError('Passwords do not match.');
      return;
    }

    if (formData.password.length < 6) {
      setRegisterError('Password must be at least 6 characters long.');
      return;
    }

    setIsLoading(true);
    setRegisterError('');

    try {
      const response = await axios.post(apiUrl + '/register', formData);

      if (response.data && response.data.user && response.data.user.tenant_id) {
        // Store JWT token and user info
        localStorage.setItem('token', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
        localStorage.setItem('selectedTenant', response.data.user.tenant_id.toString());
        window.location.href = '#/';
      } else {
        setRegisterError('Registration failed: Invalid user data returned.');
      }
    } catch (error) {
      console.error(error);
      setRegisterError(error.response?.data?.error || 'Registration failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleRegister();
    }
  };

  return (
    <div>
      <Navigation />
      <Container className="d-flex justify-content-center align-items-center min-vh-100">
        <Row className="w-100 justify-content-center">
          <Col md={6} lg={4}>
            <Card className="shadow-lg border-0 rounded-lg">
              <Card.Body className="p-5">
                <div className="text-center mb-4">
                  <PersonFillAdd className="text-primary mb-3" size={48} />
                  <h2 className="fw-bold text-primary">First Time Setup</h2>
                  <p className="text-muted">Create your admin account to get started</p>
                </div>

                {registerError && (
                  <Alert variant="danger" className="mb-3">
                    {registerError}
                  </Alert>
                )}

                <Form>
                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">Full Name</Form.Label>
                    <div className="input-group">
                      <span className="input-group-text">
                        <PersonCircle />
                      </span>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Enter your full name"
                        value={formData.name}
                        onChange={handleInputChange}
                        onKeyPress={handleKeyPress}
                        disabled={isLoading}
                      />
                    </div>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">Username</Form.Label>
                    <div className="input-group">
                      <span className="input-group-text">
                        <PersonCircle />
                      </span>
                      <Form.Control
                        type="text"
                        name="username"
                        placeholder="Choose a username"
                        value={formData.username}
                        onChange={handleInputChange}
                        onKeyPress={handleKeyPress}
                        disabled={isLoading}
                      />
                    </div>
                  </Form.Group>

                  <Form.Group className="mb-3">
                    <Form.Label className="fw-semibold">Password</Form.Label>
                    <div className="input-group">
                      <span className="input-group-text">
                        <ShieldLock />
                      </span>
                      <Form.Control
                        type="password"
                        name="password"
                        placeholder="Create a password"
                        value={formData.password}
                        onChange={handleInputChange}
                        onKeyPress={handleKeyPress}
                        disabled={isLoading}
                      />
                    </div>
                  </Form.Group>

                  <Form.Group className="mb-4">
                    <Form.Label className="fw-semibold">Confirm Password</Form.Label>
                    <div className="input-group">
                      <span className="input-group-text">
                        <ShieldLock />
                      </span>
                      <Form.Control
                        type="password"
                        name="confirmPassword"
                        placeholder="Confirm your password"
                        value={formData.confirmPassword}
                        onChange={handleInputChange}
                        onKeyPress={handleKeyPress}
                        disabled={isLoading}
                      />
                    </div>
                  </Form.Group>

                  <Button
                    variant="primary"
                    size="lg"
                    className="w-100 mb-3"
                    onClick={handleRegister}
                    disabled={isLoading}
                  >
                    {isLoading ? 'Creating Account...' : 'Create Admin Account'}
                  </Button>
                </Form>

                <div className="text-center text-muted small">
                  This will create your first admin account
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Register;